// extracted by mini-css-extract-plugin
export var center = "Section-module--center--06825";
export var description = "Section-module--description--abca9";
export var descriptionFullWidth = "Section-module--descriptionFullWidth--6be79";
export var header = "Section-module--header--fb57a";
export var section = "Section-module--section--57309";
export var subTitle = "Section-module--subTitle--4acb1";
export var title = "Section-module--title--1bb5d";